import React from 'react';
import { Nav, NavLink, NavIcon, Bars } from './NavbarElements';
import imaglogo from '../../images/logo.png';

const Navbar = ({ toggle }) => {
  return (
    <>
      <Nav>
        <NavLink to='/'></NavLink>
        <NavIcon onClick={toggle}>
          <img src={imaglogo}/> 
          
        </NavIcon>
      </Nav>
    </>
  );
};

export default Navbar;
